import { SEO_LOCALES } from "~/constants/seo";

// Localized public URLs (`/vi`, `/ja/downloader`) force the locale named in
// the path. Under `strategy: "no_prefix"` setLocale only loads the messages,
// switches the locale and syncs the cookie; it never navigates. The i18n
// middleware that runs afterwards reads the same cookie, so it agrees.
export default defineNuxtRouteMiddleware(async (to) => {
  const lang = to.params.lang;
  if (typeof lang !== "string" || !SEO_LOCALES.includes(lang)) return;
  const i18n = useNuxtApp().$i18n as { locale: { value: string }; setLocale: (l: string) => Promise<void> };
  if (i18n.locale.value !== lang) await i18n.setLocale(lang);
});
